<!-- 保密局门户首页 -->
<template>
  <div class="cm_index_container">
    <div :class="mobileClass('cm_index_box')">
      <div class="cm_mid_data">
        <component
          :is="item.type"
          :data="item"
          :key="item.id"
          v-for="item in ele.element"
          v-show="hasAlias(webConfigue, item.data)"
        ></component>
      </div>
    </div>
    <div class="cm_index_notice" v-show="tcshow">
      <div class="not-nei">
        <p @click="gbclick" :style="pcss == 1?'background: rgba(0,0,0,0.2);cursor:pointer;':''" @mouseenter="down" @mouseleave="leave">×</p>
        <img src="@/assets/img/index_notice.png" />
      </div>

    </div>

  </div>
</template>

<script>
import temp from "@/utils/importTemp.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: temp,
  data() {
    //这里存放数据
    return {
      tcshow:true,
      ele: "",
      webConfigue: JSON.parse(window.localStorage.getItem("webConfigue")),
      pcss:0,
      windowWidth:document.documentElement.clientWidth
    };
  },
  //监听属性 类似于data概念
  computed:{
    mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
  },
  //监控data中的数据变化
  watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
  //方法集合
  methods: {
    down(){
      this.pcss = 1
    },
    leave(){
      this.pcss = 0
    },
    gbclick(){
      this.tcshow = false
    },
    hasAlias: function (arr, alias1) {
      let alias = ""
      if (alias1 != "" && alias1 != undefined && alias1 != null) {
        alias = alias1.channelId
        for (let i = 0; i < arr.length; i++) {
          if (
            arr[i][this.ele.alias] != "" &&
            arr[i][this.ele.alias] != undefined &&
            arr[i][this.ele.alias] != null
          ) {
            for (let j = 0; j < arr[i][this.ele.alias].length; j++) {
              if (arr[i][this.ele.alias][j].TEMPLATE_ID == alias) {
                return true;
              }
            }
          }
        }
        return false
      }else{
        return true;
      }

    },
    loadItem() {
      let navList = this.$store.state.comData.navList;
      for (let i = 0; i < navList.length; i++) {
        if (navList[i].path == this.$route.path) {
          this.ele = navList[i];
        }
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loadItem();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
.cm_index_container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cm_index_box {
  width: 1200px;
}
.cm_mid_data {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}
.cm_index_notice {
  position: fixed;
  top: 20%;
  right: 0px;
  z-index: 50;
  display: block;
}
  .not-nei{
    position: relative;
  }
  .not-nei p:first-child{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;

    position: absolute;
    right:0px;
    top: 6px;
    font-size: 20px;
    color: #fff;
  }

.mobile_cm_index_box{
  width: 80%;
}
</style>
